"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateTable = void 0;
const value_wrappers_1 = require("../value-wrappers");
const index_1 = __importDefault(require("./index"));
function evaluateTable(table, state) {
    let error = null;
    if (!table.rows)
        return (0, value_wrappers_1.makeError)('There is no data for the table.');
    const data = table.rows.map((row) => {
        return row.map((cell) => {
            const cellData = index_1.default.evaluatePlaceholders(cell, state);
            if (!error && cellData.kind === 'error')
                error = cellData;
            return cellData.value;
        });
    });
    return error ? error : (0, value_wrappers_1.makeValue)({ title: table.title, rows: data });
}
exports.evaluateTable = evaluateTable;
